import styled from 'styled-components';

import { colors } from '../../styles/colors';
import { colors as remoteControlColors } from '../../styles/remoteControlColors';

export type ToggleSwitchMiniVariants = 'remote-control' | 'default-thin' | 'default';

export const Slider = styled.div<{ width, checked, variant }>`
  line-height: 0;
  display: inline-block;
  width: ${({ width }) => width}px;
  height: 26px;
  border-radius: 13px;
  padding-top: 5px;
  position: relative;
  -webkit-transition: .4s;
  transition: .4s;
  ${({ checked, variant }) => {
    if (variant) {
      return 'background-color: #ccc;';
    }
    return (checked ? `background-color: ${colors.BlueSecondary};` : 'background-color: #ccc;');
  }}
  ${({ checked, width }) => (checked ? `padding-left: ${(width - 21)}px;` : 'padding-left: 4px;')}
`;

export const StateLabelChecked = styled.span<{ width }>`
  font-size: 60%;
  text-align: center;
  position: absolute;
  line-height: normal;
  width: ${({ width }) => (width - 30)}px;
  left: 5px;
  top: 7px;
  color: black;
`;

export const StateLabelUnchecked = styled.span<{ width }>`
  font-size: 60%;
  text-align: center;
  position: absolute;
  line-height: normal;
  width: ${({ width }) => (width - 30)}px;
  left: 23px;
  top: 7px;
  color: black;
`;

export const Cursor = styled.div<{ checked, variant }>`
  line-height: 0;
  display: inline-block;
  width: 16px;
  height: 16px;
  border: 0;
  border-radius: 50%;
  ${({ checked, variant }) => {
    if (variant) {
      return (checked ? 'background-color: green;' : 'background-color: red;');
    }
    return 'background-color: #fff;';
  }}
`;

export const Container = styled.div<{ disabled?: boolean, variant?: ToggleSwitchMiniVariants }>`
  display: inline-block;
  cursor: pointer;

  ${({ variant }) => handleContainerStylesByVariant(variant)}

  ${({ disabled }) => (disabled ? `
    pointer-events: none;
    opacity: 0.3;
  ` : '')}
`;

export const handleContainerStylesByVariant = (variant?: ToggleSwitchMiniVariants): string => {
  if (variant === 'remote-control') {
    return `
      color: ${remoteControlColors.Grey};
    `;
  }

  if (variant === 'default-thin' || variant === 'default') {
    return `
      color: ${colors.text['main-900']};
      font-size: 14px;
      font-weight: 400;
    `;
  }

  return `
      color: ${colors.DarkGrey};
    `;
};

export const SliderMini = styled.div<{ checked?: boolean, variant?: ToggleSwitchMiniVariants, withoutMediaRemoteControl?: boolean }>`
  line-height: 0;
  display: inline-block;
  width: 30px;
  height: 16px;
  border-radius: 13px;
  padding-top: 2px;
  position: relative;
  -webkit-transition: .4s;
  transition: .4s;

  ${({ variant, checked, withoutMediaRemoteControl }) => handleSliderStylesByVariant(checked, variant, withoutMediaRemoteControl)}
`;

const handleSliderStylesByVariant = (checked?: boolean, variant?: ToggleSwitchMiniVariants, withoutMediaRemoteControl?: boolean) => {
  if (!variant) {
    const padding = checked ? 'padding-left: 16px;' : 'padding-left: 2px;';

    return `
      background-color: '#ccc';
      ${padding}
    `;
  }

  const defaultBackground = `
    background-color: ${checked ? remoteControlColors.Green500 : remoteControlColors.Grey400};
  `;

  if (variant === 'remote-control' || variant === 'default') {
    return `
    ${defaultBackground}
    ${remoteControlStyles(checked, withoutMediaRemoteControl)}
  `;
  }

  if (variant === 'default-thin') {
    return `
    ${defaultBackground}
    ${defaultThinStyles(checked)}
  `;
  }
};

const remoteControlStyles = (checked?: boolean, withoutMediaRemoteControl?: boolean) => {
  const defaultStyles = `
  transition: background-color 200ms linear;
  transition: padding 100ms linear;
  `;

  if (!withoutMediaRemoteControl) {
    return `
      ${defaultStyles}
      height: 20px;
      width: 40px;
      ${checked ? 'padding-left: 22px' : 'padding-left: 2px'};
    `;
  }

  return `
    ${defaultStyles}
    ${checked ? 'padding-left: 22px' : 'padding-left: 2px'};
  `;
};

const defaultThinStyles = (checked?: boolean) => `
  height: 12px;
  width: 24px;
  padding-top: 1px;
  padding-left: ${checked ? '13px' : '1px'};
`;

export const CursorMini = styled.div<{ checked: boolean, onOff?: boolean, variant?: ToggleSwitchMiniVariants, withoutMediaRemoteControl?: boolean }>`
  line-height: 0;
  display: inline-block;
  width: 12px;
  height: 12px;
  border: 0;
  border-radius: 50%;

  ${({
    onOff, checked, variant, withoutMediaRemoteControl,
  }) => handleCursorStylesByVariant(variant, checked, onOff, withoutMediaRemoteControl)}
`;

const handleCursorStylesByVariant = (variant?: ToggleSwitchMiniVariants, checked?: boolean, onOff?: boolean, withoutMediaRemoteControl?: boolean) => {
  if (!variant) {
    if (onOff) return checked ? 'background-color: black;' : `background-color: ${colors.BlueSecondary};`;
    return `background-color: ${colors.BlueSecondary};`;
  }

  const defaultBackground = `background-color: ${remoteControlColors.White};`;

  if (variant === 'remote-control' || variant === 'default') {
    const media = withoutMediaRemoteControl ? '' : `
    height: 16px;
    width: 16px;
    `;

    return `
      ${defaultBackground}
      ${media}
    `;
  }

  if (variant === 'default-thin') {
    return `
      ${defaultBackground}
      width: 10px;
      height: 10px;
    `;
  }
};
